/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

window.productAdded = function productAdded(n) {
  document.dispatchEvent(new CustomEvent('product:added', {
    bubbles: true,
    detail: {
      variant: {},
      quantity: parseInt(n || 0, 10)
    }
  }));
};

/*\
|*|
|*|  :: cookies.js ::
|*|
|*|  A complete cookies reader/writer framework with full unicode support.
|*|
|*|  https://developer.mozilla.org/en-US/docs/DOM/document.cookie
|*|
|*|  This framework is released under the GNU Public License, version 3 or later.
|*|  http://www.gnu.org/licenses/gpl-3.0-standalone.html
|*|
|*|  Syntaxes:
|*|
|*|  * docCookies.setItem(name, value[, end[, path[, domain[, secure]]]])
|*|  * docCookies.getItem(name)
|*|  * docCookies.removeItem(name[, path], domain)
|*|  * docCookies.hasItem(name)
|*|  * docCookies.keys()
|*|
\*/

var docCookies = {
  getItem: function (sKey) {
    return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[-.+*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
  },
  setItem: function (sKey, sValue, vEnd, sPath, sDomain, bSecure) {
    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) { return false; }
    var sExpires = "";
    if (vEnd) {
      switch (vEnd.constructor) {
        case Number:
          sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
          break;
        case String:
          sExpires = "; expires=" + vEnd;
          break;
        case Date:
          sExpires = "; expires=" + vEnd.toUTCString();
          break;
      }
    }
    document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
    return true;
  },
  removeItem: function (sKey, sPath, sDomain) {
    if (!sKey || !this.hasItem(sKey)) { return false; }
    document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + ( sDomain ? "; domain=" + sDomain : "") + ( sPath ? "; path=" + sPath : "");
    return true;
  },
  hasItem: function (sKey) {
    return (new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[-.+*]/g, "\\$&") + "\\s*\\=")).test(document.cookie);
  },
  keys: function () {
    var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);
    for (var nIdx = 0; nIdx < aKeys.length; nIdx++) { aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]); }
    return aKeys;
  }
};

function updatePromoBar() {
  // 获取购物车容器
  const cartContainer = document.getElementById('sidebar-cart');
  if (!cartContainer) {
    console.error('Cart container not found!');
    return;
  }

  // 获取所有 CartItem
  const cartItems = cartContainer.querySelectorAll('.CartItem');
  
  // 初始化符合条件的商品总数量
  let validItemQuantity = 0;

  // 遍历每个 CartItem
  cartItems.forEach((item) => {
    // 检查是否不包含 data-bfcm24-outlet="true"
    if (item.getAttribute('data-bfcm24-outlet') !== 'true') {
      const quantity = parseInt(item.getAttribute('data-quantity'), 10) || 0;
      validItemQuantity += quantity; // 累加数量
    }
  });

  // 根据数量更新进度条
  const promoBar = document.querySelector('.CollectionMain global-cart-progress-bar');
  if (!promoBar) {
    console.error('Promo bar not found!');
    return;
  }

  // 动态设置进度条宽度和激活状态
  let progressWidth = '0%';
  if (validItemQuantity >= 4) {
    progressWidth = '100%';
  } else if (validItemQuantity === 3) {
    progressWidth = '75%';
  } else if (validItemQuantity === 2) {
    progressWidth = '50%';
  } else if (validItemQuantity === 1) {
    progressWidth = '25%';
  }

  // 更新进度条宽度
  promoBar.style.setProperty('--progress-bar-width', progressWidth);

  // 更新每个阶段的激活状态
  const stages = promoBar.querySelectorAll('.CollectionMain .cart-progress-bar__item');
  stages.forEach((stage) => {
    const threshold = parseInt(stage.getAttribute('data-threshold'), 10) || 0;
    if (validItemQuantity >= threshold) {
      stage.setAttribute('data-active', '');
    } else {
      stage.removeAttribute('data-active');
    }
  });

  console.log(`Promo bar updated. Valid item quantity: ${validItemQuantity}`);
}



const checkItemsOnCart = (cart,action) => {
  window.SpringSaleAutoGift && window.SpringSaleAutoGift.sync();
  // let stackingTOB = 0;
  // let stackingCenter = 0;
  // let stacking_handle = 'brilliant-round-wishbone-stacking-ring,pear-wishbone-stacking-ring,pave-wishbone-v-stacking-ring,pave-hex-stacking-ring,open-pave-wishbone-stacking-ring,kite-stacking-ring,pave-horseshoe-stacking-ring,wishbone-v-stacking-ring,graduated-pear-stacking-ring';
  // let stacking_center_handle = 'crushed-ice-pear-trio-statement-ring,crushed-ice-square-statement-ring,crushed-ice-rectangle-side-kite-statement-ring,crushed-ice-oval-multi-statement-ring,crushed-ice-pear-multi-statement-ring,crushed-ice-rectangle-trio-statement-ring';
  // let has_free_case = false ;
  // let _free_case = '' ;
  // for (i=0;i<cart.items.length;i++) {
  //   let line_item = cart.items[i];
  //   if (stacking_handle.indexOf(line_item.handle)!= -1){
  //     stackingTOB += 1 * line_item.quantity;
  //   }
  //   if (stacking_center_handle.indexOf(line_item.handle)!= -1){
  //     stackingCenter += 1 * line_item.quantity;
  //   }
  //   if (line_item.handle.indexOf('jewellery-travel-case-5324380') != -1) {
  //     _free_case = line_item.key
  //   }

  // }
  // if (stackingCenter>= 1 && stackingTOB >= 1) {
  //   has_free_case = true  
  // }
  // if (cart.items.length == 0) {
  //   docCookies.removeItem('STACKINGVIPFREEGIFT')
  // }


  // if(!has_free_case && _free_case !=''){
  //   let updateData = {}
  //   updateData[""+_free_case+""] =  0;
  //   $.ajax({
  //     type: 'POST',
  //     url: '/cart/update.js',
  //     data: {
  //       updates: updateData
  //     },
  //     dataType: 'json',
  //     success: function(cart){ 
  //       docCookies.removeItem('STACKINGVIPFREEGIFT')
  //       //刷新 drawer cart
  //       setTimeout(function(){
  //         productAdded()
  //       }, 1000);
  //     },
  //     error: function(err){ console.error('Booo!', err) }
  //   });
  // }

  // setTimeout(function(){
  //   updatePromoBar()
  // }, 1000);
  
}


//js获取url参数值
function getQueryString(name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    let r = window.location.search.substr(1).match(reg);
    if (r != null) {
        return decodeURIComponent(r[2]);
    };
    return null;
}

//删除url中参数
function delUrlParam(param){
  let obj = new window.URL(window.location.href);
  obj.searchParams.delete(param);
  return obj.href;
}


function __addToCart(datas) {
  document.dispatchEvent(new CustomEvent("theme:loading:start"));
  fetch('/cart/add.js', {
    body: JSON.stringify(datas),
    credentials: 'same-origin',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
    }
  }).then(function (cart) {
      setTimeout(function(){
        productAdded(1)
      }, 1000);
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
  }).catch((error) => {
    console.error('Error:', error);
  });
  return false;
}

function __customAddToCart(button,id,quantity) {
  let this_button = $(button);
  toggleLoading(this_button)
  let uuid = uuidv4();
  let properties_msg = this_button.attr('data-msg') ? this_button.attr('data-msg') : '';
  let add_to_cart_datas = [];
  let add_to_cart_data = {
      "id":id,
      "quantity": quantity,
      "properties": {
        "_uuid":uuid,
        "_msg": properties_msg,
      }
  };
  add_to_cart_datas.push(add_to_cart_data);
  fetch('/cart/add.js', {
    body: JSON.stringify({items:add_to_cart_datas}),
    credentials: 'same-origin',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
    }
  }).then(function (response) {
      console.log(response)
      if (response.status == 200) {
        toggleLoading(this_button)
        log_product_action(id,uuid,1,properties_msg)
        $.fancybox.close();
        // $.fancybox.destroy();
        productAdded()
      }else{
        let response_json = response.json();
        response_json.then(function (result) {
          // _this.cart_error_message = result.description
          $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + result.description);
        })
        toggleLoading(this_button)
      }
      
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      
  }).catch((error) => {
    console.error('Error:', error);
  });
  return false;
}

function loadCssCode(code) {
  var style = document.createElement('style')
  style.type = 'text/css'
  style.rel = 'stylesheet'
  try {
    //for Chrome Firefox Opera Safari
    style.appendChild(document.createTextNode(code))
  } catch (ex) {
    //for IE
    style.styleSheet.cssText = code
  }
  var head = document.getElementsByTagName('head')[0]
  head.appendChild(style)
}


function closeDrawerupsell () {
    $('.Drawer_upsell').remove();
  loadCssCode('.Drawer_upsell{display:none;}')

}

function bfcmSavings() {
  // 获取所有包含 data-calculate-savings="true" 的元素
  const elements = document.querySelectorAll('[data-calculate-savings="true"]');

  // 遍历每个元素
  elements.forEach(element => {
      // 获取前面的兄弟节点，分别是原价和折扣价
      const originalPrice = parseFloat(element.previousElementSibling.previousElementSibling.innerText.slice(1));
      const discountedPrice = parseFloat(element.previousElementSibling.innerText.slice(1));

      // 计算折扣百分比并四舍五入
      const discountPercentage = Math.round(((originalPrice - discountedPrice) / originalPrice) * 100);

      // 将结果赋值给当前元素
      element.innerText = `(${discountPercentage}% Savings)`;
  });
}

function exchangeRateText () {
  let exchangeRate = GeoCurrencyRate;
  // exchangeRateStorage.save(exchangeRate);
  // moneyFormatStorage.save(window.theme.moneyFormat)
  let moneyNodes = document.querySelectorAll('[data-money]');
  
  for(i=0;i<moneyNodes.length;i++){
    let toFixed = moneyNodes[i].getAttribute("data-money-round") ? moneyNodes[i].getAttribute("data-money-round") : 2;
    let compareAtPrice = moneyNodes[i].closest('.ProductItem__PriceList') ? moneyNodes[i].closest('.ProductItem__PriceList').querySelector('.Price--compareAt') : 0;
    let exchangeMoney =  (moneyNodes[i].getAttribute("data-money")* exchangeRate / 100).toFixed(toFixed);
    
    let formatExchangeMoney = Shopify.formatMoney( exchangeMoney* 100,window.theme.moneyFormat).replace('.00','');
    
    moneyNodes[i].innerHTML = '<span data-money-convertible>'+formatExchangeMoney+'</span>';
    if (compareAtPrice) {
      console.log(compareAtPrice);
      let _compare_at_price = stringToNumer(compareAtPrice.innerHTML);
      let _price = stringToNumer(formatExchangeMoney);
      let _discount_number = Math.round(( _compare_at_price - _price ) / _compare_at_price * 100);
      let fixedLabel = moneyNodes[i].closest('.ProductItem__Wrapper').querySelector('.fixed-label');
      if (fixedLabel) {
        fixedLabel.innerHTML = _discount_number + fixedLabel.innerHTML;
        fixedLabel.classList.remove('fixed-label')
      }
    }
  }
  // setTimeout(function() {
  //   bfcmSavings()
  // }, 300);
}

function uuidv4() {
  return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}

function toggleLoading (button) {
  if (button.hasClass('loading')) {
    button.removeClass('loading');
    button.find('.loading-overlay__spinner').addClass('hidden');
    if (!button.hasClass('is_soldout')) {
      button.attr("disabled", false);
    }
  }else {
    button.addClass('loading');
    button.find('.loading-overlay__spinner').removeClass('hidden');
    button.attr("disabled", true);
  }
  
}

function stringToNumer(str) {
  let regex = /[-]{0,1}[\d,]*[\.]{0,1}[\d]+/g;
  let matches = str.match(regex);
  return matches.length == 1 ? parseFloat(matches[0].replace(/,/g, '')) : matches.map(match => parseFloat(match.replace(/,/g, '')));
}

/**
 * Determine the mobile operating system.
 * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
 *
 * @returns {String}
 */
function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone";
  }

  if (/android/i.test(userAgent)) {
    return "Android";
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/Safari/.test(userAgent) && !window.MSStream) {
    return "Safari";
  }

  return "unknown";
}